"use strict";import{Textfield as e}from"./src/Textfield.js";import{defineElement as t}from"@spectrum-web-components/base/src/define-element.js";t("sp-textfield",e);
//# sourceMappingURL=sp-textfield.js.map
